export const LinkedinIcon: React.FC<{ width?: number }> = () => {
	return (
		<svg
			fill="none"
			height="20"
			viewBox="0 0 20 20"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.375 2.5H3.625C3 2.5 2.5 3 2.5 3.5625V16.375C2.5 16.9375 3 17.4375 3.625 17.4375H16.375C17 17.4375 17.5 16.9375 17.5 16.375V3.5625C17.5 3 17 2.5 16.375 2.5ZM6.9375 15.25H4.75V8.125H6.9375V15.25ZM5.875 7.125C5.1875 7.125 4.5625 6.5625 4.5625 5.8125C4.5625 5.0625 5.125 4.5 5.875 4.5C6.5625 4.5 7.1875 5.0625 7.1875 5.8125C7.1875 6.5625 6.5625 7.125 5.875 7.125ZM15.3125 15.1875H13.125V11.6875C13.125 10.875 13.125 9.75 11.9375 9.75C10.75 9.75 10.625 10.6875 10.625 11.5625V15.125H8.4375V8.125H10.5V9.0625H10.5625C10.875 8.5 11.625 7.875 12.6875 7.875C14.9375 7.875 15.375 9.375 15.375 11.3125V15.1875H15.3125Z"
				fill="#007EBB"
			/>
		</svg>
	);
};
